import { render, staticRenderFns } from "./moves.vue?vue&type=template&id=332fc77f&"
import script from "./moves.vue?vue&type=script&lang=js&"
export * from "./moves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports